export default __webpack_public_path__ + "static/media/Ring of the Serpent Father.e64c9edc.jpg";